import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const encuestasmodule = {
	state: {
		encuestas : '',
		showencuestas : false
	},
	getters: {
   		getEncuestas : state => state.encuestas,
   		getShowEncuestas : state => state.showencuestas,
	},
	actions: {
    	setEncuestas({commit},encuestas){
    		commit('setEncuestas',encuestas);
    		commit('showEncuestas')
    	},
    	hideEncuestas({commit},encuestas){
    		commit('hideEncuestas');
    	}
	},
	mutations: {
		setEncuestas(state,encuestas){


			if(!encuestas.titulo){
				let array = new Array();
				array = encuestas;
				state.encuestas = array;
			}else{
				state.encuestas = new Array();
				state.encuestas[0] = encuestas;
			}
		},
     	hideEncuestas(state){
     		state.showencuestas = false;
     	},
     	showEncuestas(state){
     		state.showencuestas = true;
     	},
        removeEncuestas(state){
            state.encuestas = '';
            state.showencuestas = false;
        }
	}
}

export default encuestasmodule;


// WEBPACK FOOTER //
// ./src/store/encuestasmodule.js